function checkViewsLimit(key) {
    if (!localStorage.getItem(key)) {
        localStorage.setItem(key, "1");

        return true;
    }

    const value = +localStorage.getItem(key);

    if (value >= 3) {
        return false;
    }

    localStorage.setItem(key, value + 1);

    return true;
}

function pingOnIntersection(element, id, token) {
    const logView = () => {
        const body = new FormData();

        body.append("token", token);
        body.append("position", "post");

        fetch(`/post-info/${id}/view`, {
            method: "POST",
            body: body,
        });
    };
    const callback = (entries, observer) => {
        entries
            .filter((entry) => entry.isIntersecting)
            .forEach(() => {
                logView();
                observer.disconnect();
            });
    };
    const observer = new IntersectionObserver(callback, {
        threshold: 1,
    });

    observer.observe(element);
}

function init(container) {
    const id = container.dataset.imageBanner;
    const token = container.dataset.token;
    const storageKey = "image_banner_" + id;
    const desktop = container.querySelector("[data-b-desktop]");
    const mobile = container.querySelector("[data-b-mobile]");

    if (!checkViewsLimit(storageKey)) {
        return false;
    }

    container.style.display = "block";

    pingOnIntersection(desktop, desktop.dataset.bDesktop, token);
    pingOnIntersection(mobile, mobile.dataset.bMobile, token);

    return true;
}

export default function useImageBanner() {
    Array.from(document.querySelectorAll("[data-image-banner]")).some((item) =>
        init(item)
    );
}
